import moment from "moment";
import React, { useRef, useState } from "react";
import ReactDatePicker from "react-datepicker";
import MultiSelect from "react-select";
import "react-datepicker/dist/react-datepicker.css";
import { SlCalender } from "react-icons/sl";
import { FaCalendarAlt, FaFileImage, FaFileUpload } from "react-icons/fa";
import { LogoImg2 } from "assets/images";

export const Input = ({
  type,
  value,
  onChange,
  className,
  label,
  error,
  extraErr = false,
  required,
  optional,
  loading,
  leftIcon,
  ...rest
}) => {
  const classGenerator = () => {
    if (extraErr) {
      return "is-invalid";
    }
    if (error && !value) {
      return "is-invalid";
    }
  };

  // return (
  //   <>
  //   <div>
  //     {label && <label className="label">{label}</label>}
  //     {required && <span className="text-danger"> *</span>}
  //     </div>
  //     <input
  //       type={type}
  //       value={value}
  //       onChange={onChange}
  //       className={`${className} ${classGenerator()}`}
  //       {...rest}
  //       loading={loading ? "" : ""}
  //     />
  //     {leftIcon}
  //     {error && <div className="invalid-feedback">{error}</div>}
  //   </>
  // );

  // console.log(error, "error");
  return (
    <>
      {label && <label className="label">{label}</label>}
      {required && <span className="text-danger"> *</span>}
      <input
        value={value}
        type={type}
        onChange={onChange}
        className={`form-control input ${className} ${classGenerator()}`}
        {...rest}
        loading={loading ? "" : ""}
      />
      {leftIcon}
      {error && <div className="invalid-feedback">{error}</div>}
      {/* {error && <span className="invalid-feedback">{error}</span>} */}
    </>
  );
};

export const Select = ({
  label,
  onChange,
  value,
  error,
  extraErr = false,
  className,
  children,
  required,
  loading,
  ...rest
}) => {
  const classGenerator = () => {
    if (extraErr) {
      return "is-invalid";
    }
    if (error && !value) {
      return "is-invalid";
    }
  };

  return (
    <>
      {label && <label className="label">{label}</label>}
      <select
        onChange={onChange}
        value={value}
        className={`form-control input ${className} ${classGenerator()}`}
        {...rest}
        loading={loading ? "" : ""}
      >
        {children}
      </select>
      {error && <div className="invalid-feedback">{error}</div>}
    </>
  );
};

export const TextArea = ({
  value,
  onChange,
  label,
  className,
  error,
  required,
  loading,
  ...rest
}) => {
  return (
    <>
      {label && <label className="label">{label}</label>}
      {required && <span className="text-danger"> *</span>}
      <textarea
        value={value}
        onChange={onChange}
        className={`form-control input ${className} ${
          !value && error && "is-invalid"
        }`}
        {...rest}
        loading={loading ? "" : ""}
      />
      {error && <div className="invalid-feedback">{error}</div>}
    </>
  );
};

export const DatePicker = ({
  label,
  required,
  placeholder,
  error,
  className,
  name,
  selected,
  onChange,
  maxDate,
  minDate,
  ...rest
}) => {
  return (
    <>
      <div className="custom_date_picker">
        {label && <label className="label">{label}</label>}
        {required && <span className="text-danger"> *</span>}

        <ReactDatePicker
          placeholderText={placeholder}
          className={`form-control input date_picker ${className} ${
            !selected && error && "is-invalid"
          }`}
          name={name}
          showIcon
          // icon={<SlCalender className="calender_icon" />}
          // isClearable
          icon={<FaCalendarAlt />}
          showYearDropdown
          yearDropdownItemNumber={10}
          scrollableYearDropdown
          showMonthDropdown
          // useShortMonthInDropdown
          selected={selected ? new Date(selected) : null}
          onChangeRaw={(e) => e.preventDefault()}
          onChange={(date) =>
            onChange(date) ? (date) => onChange(date) : onChange
          }
          dateFormat="dd-MM-yyyy"
          maxDate={maxDate ? new Date(maxDate) : null}
          minDate={minDate ? new Date(minDate) : null}
          {...rest}
        />
        {error && (
          <p className={`invalid-feedback ${!selected && "d-block"}`}>
            {error}
          </p>
        )}
      </div>
    </>
  );
};

// const options = [
//   { value: 'apple', label: 'Apple' },
//   { value: 'banana', label: 'Banana' },
//   { value: 'orange', label: 'Orange' },
// ]

export const CommonSelect = ({
  label,
  onChange,
  value,
  error,
  className = "",
  options = [],
  isMulti = false,
  isSearchable = false,
  noOptionsMessage = () => "No options found",
  required = false,
  loading = false,
  isDisabled = false,
  placeholder = "Select",
  ...rest
}) => {
  // console.log('error   CommonSelect-->', error)
  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "linear-gradient(180deg, #01b4a7 0%, #00aace 100%)"
        : "#fff", // Change background color of selected option
      color: state.isSelected
        ? "linear-gradient(180deg, #01b4a7 0%, #00aace 100%)"
        : "black", // Change text color of selected option
      "&:hover": {
        backgroundColor: "linear-gradient(180deg, #01b4a7 0%, #00aace 100%)", // Change background color of option on hover
        color: "#222", // Change text color of option on hover
      },
    }),
    loadingIndicator: (base, state) => ({
      ...base,
      color: "#FF8989", // Set the color to red
    }),
  };

  const handleChange = (selectedOptions) => {
    onChange(selectedOptions);
  };
  return (
    <div className="custom_select">
      {label && <label className="label">{label}</label>}
      {required && <span className="text-danger"> *</span>}

      <MultiSelect
        onChange={handleChange}
        value={value}
        className={`form-control input multi_select ${className} ${
          !value && error && "is-invalid"
        }`}
        options={options}
        isMulti={isMulti}
        placeholder={placeholder}
        isSearchable={isSearchable}
        noOptionsMessage={noOptionsMessage}
        isLoading={loading}
        styles={customStyles}
        isDisabled={isDisabled}
        classNamePrefix="react_select"
        {...rest}
      />
      {/* {leftIcon} */}
      {error && <div className="invalid-feedback">{error}</div>}
    </div>
  );
};

// mui checkbox

// function CheckboxGroup({
//   name = '',
//   label = '',
//   checked,
//   onChange,
//   className = '',
//   value,
// }) {
//   return (
//     <FormControl component="fieldset" variant="standard">
//       <FormGroup>
//         <FormControlLabel
//           control={
//             <Checkbox
//               className={className}
//               checked={checked}
//               onChange={onChange}
//               value={value}
//               name={name}
//               sx={{
//                 color: '#FF8989',
//                 '&.Mui-checked': {
//                   color: '#FF8989',
//                 },
//               }}
//             />
//           }
//           label={label}
//         />
//       </FormGroup>
//     </FormControl>
//   )
// }

// export default CheckboxGroup

// export const dateFormat = (date) => {
//   return date ? moment(date).format('DD-MM-yyyy') : '---'
// }

export const dateMonthFormat = (date) => {
  return date ? moment(date).format("DD MMM yyyy") : "---";
};
export const timeFormat = (time) => {
  return time ? moment(time, "HH:mm").format("h:mm A") : "---";

};
export const eventTime = (date) => {
  const dateTime = new Date(date); // Local time 14:30
const time = `${String(dateTime.getHours()).padStart(2, '0')}:${String(dateTime.getMinutes()).padStart(2, '0')}`;
console.log(time); // ✅ "14:30" (Correct local time)
let times=timeFormat(time)
  return times;

};


export const searchDateFormat = (date) => {
  // return date ? moment(date).format("DD-MM-yyyy") : ""

  return date ? moment(date).format("yyyy-MM-DD") : "";
};

export const FileUpload = () => {
  return (
    <>
      <div className="simple_file_upload">
        <input type="file" id="fileUpload" />
        <label htmlFor="fileUpload">
          <b>Choose file</b>
          <span>Logo-file-name.png</span>
        </label>
        {/* <img src={LogoImg2} alt="" /> */}
      </div>
    </>
  );
};

export const ImageUpload = () => {
  const [imagePreview, setImagePreview] = useState(false);
  return (
    <>
      <div className="image_upload_wrap">
        <input type="file" id="imageUploader" />
        <label htmlFor="imageUploader">
          {imagePreview ? (
            <>
              {/* <FaFileUpload /> */}
              <p>Upload your file, click to browse</p>
            </>
          ) : (
            <>
              <div className="image_Preview">
                <img src={LogoImg2} alt="" />
              </div>
            </>
          )}
        </label>
      </div>
    </>
  );
};
